import React, { PropsWithChildren, useCallback, useContext, useMemo } from 'react'
import { useNavigate } from 'react-router'
import AdminAuthWrapper from '../Auth/AdminAuthWrapper'
import AdminUserContext from '../context/AdminUser'
import api from '../helpers/api'
import { SidenavUserData, LoggedTemplate } from '../Korbantech'
import { ADMIN_MENU_ITEMS, BRAND_LOGO } from '../utils/constants'

const AdminLayout = ({ children, pageTitle }: Props) => {
    const { state: user, setState: setUser } = useContext(AdminUserContext)
    const navigate = useNavigate()

    const logo = useMemo(() => {
        return BRAND_LOGO
    }, [])

    const logout = useCallback(async () => {

        if (!user) return
        const headers = {
            Authorization: `Bearer ${user?.access_token}`
        }
        await api.get('admin/auth/logout', { headers }).then(() => {
            setUser(undefined)
            window.location.reload()
        }).catch(console.log)
    }, [setUser, user])

    const userData: SidenavUserData = useMemo(() => {
        return {
            name: user?.name ?? '',
            logout,
        }
    }, [user, logout])

    const menuItems = useMemo(() => {
        return ADMIN_MENU_ITEMS.map(menu => ({
            ...menu,
            action: () => menu.to && navigate(menu.to)
        }))
    }, [navigate])

    return (
        <AdminAuthWrapper>
            <LoggedTemplate
                isLogged={user !== undefined}
                brandLogoUrl={logo}
                userData={userData}
                menuItems={menuItems}
                pageTitle={pageTitle}
                bg_color={'bg-white'}
                sideNavUserColor={'bg-gray-50'}
                sideNavUserTextColor={'text-gray-800'}
                hoverColor={'bg-primary'}
                hoverText={' text-white '}
                textColor={'text-gray-800'}
            >
                <div className='px-12 mt-5 pt-7'>
                    {children}
                </div>
            </LoggedTemplate>
        </AdminAuthWrapper>
    )
}

interface Props extends PropsWithChildren<any> {
    pageTitle?: string,
    useMallContext?: boolean
}

export { AdminLayout }
